var Feedback = {
    'alert': function (object) {
        alert(object.Message);
    },

    'pop': function (title, mainMessage, message, refresh, onClose) {
        try {
            if (typeof(onClose) == 'undefined') {
                onClose = '';
            }

            Pop.open(
                    'feedback',
                    'Pattern/Feedback/Pop/Feedback',
                    'Title=' + title + '&MainMessage=' + mainMessage + '&Message=' + message + '&RefreshOnClose=' + parseInt(refresh) + '&onClose=' + onClose,
                    'default', {}
                    );
        } catch (e) {
            alert(e);
        }
    },

    'form': function (object) {
        // object.form == id do form
        var form = object.form;
        var fields = object.fields;
        var i, $field, $fieldContainer;

        Feedback.formClear(form);

        jQuery('#' + form + '_FeedBack').addClass('alert')
                .html('<p class="content nomargin"><strong>Ops... Verifique os itens abaixo:</strong></p>');

        for (i = 0; i < fields.length; i++) {
            $field = jQuery('#' + form + '_' + fields[i].Name + '_Feedback');
            $fieldContainer = $field.parent();

            $fieldContainer.addClass('alert_field');
            $field.addClass('alert_inline');

            $field.html('<p class="nomargin">' + fields[i].Message + '<p>');
        }
    },

    'formClear': function (form) {
        escondeLoader();

        // form == id do form

        var $form = jQuery('#' + form); //+ '_FeedBack');

        $form.removeClass('alert'); //.html('');

        var fElements = jQuery(':input', $form);

        fElements.each(function() {

            var fElem = jQuery('#' + form + '_' + this.name + '_Feedback');
            var container = fElem.parent();
            container.removeClass('alert_field');

            fElem.removeClass('alert_inline').siblings(':input').removeClass('alert_field');

            fElem.html('');
        });
    },

    'showMessage': function(message, form) {
        var $form;
        // Verify if it's a string or HTML element
        if (typeof(form) === 'string') {
            $form = jQuery('#' + form);
        } else {
            $form = jQuery(form);
        }

        var idForm = $form.attr('id');

        var formFeedback = jQuery('#' + idForm + '_FeedBack');

        formFeedback.addClass('alert').html('<p class="content nomargin"><strong>' + message + '</p');
    }
};